import { render, staticRenderFns } from "./input-suggestions.vue?vue&type=template&id=0d63d22d&"
import script from "./input-suggestions.vue?vue&type=script&lang=js&"
export * from "./input-suggestions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports